const { PerspectiveCamera } = require('three');
const { OrbitControls } = require('./OrbitControls');

const CAMERA_FOV = 70;
const CAMERA_NEAR_PLANE = 1;
const CAMERA_FAR_PLANE = 1100;
const CAMERA_ZOOM_SPEED = 0.01;
const CAMERA_ZOOM_MIN = 1;
const CAMERA_ZOOM_MAX = 4;
const CAMERA_ROTATE_SPEED = 0.35;
const CAMERA_ANGLE_MIN = 1;
const CAMERA_ANGLE_MAX = 2;

class OrbitalCamera extends PerspectiveCamera {
  constructor(renderer) {
    const aspectRatio = renderer.clientWidth / renderer.clientHeight;
    super(CAMERA_FOV, aspectRatio, CAMERA_NEAR_PLANE, CAMERA_FAR_PLANE);

    // Move camera slightly off center in order for rotation controls to work.
    this.position.x = 1;

    this.controls = new OrbitControls(this, renderer);
    this.controls.rotateSpeed = CAMERA_ROTATE_SPEED;
    this.controls.minPolarAngle = CAMERA_ANGLE_MIN;
    this.controls.maxPolarAngle = CAMERA_ANGLE_MAX;
    this.controls.enableZoom = false;

    // Use custom zoom since OrbitControls moves the camera rather than zooming.
    renderer.addEventListener('wheel', (event) => {
      event.preventDefault(); // prevent scrolling
      let zoom = this.zoom;
      zoom += event.deltaY * -CAMERA_ZOOM_SPEED;
      zoom = Math.min(Math.max(CAMERA_ZOOM_MIN, zoom), CAMERA_ZOOM_MAX);
      this.zoom = zoom;
      this.updateProjectionMatrix();
    });
  }

  resetPosition() {
    this.position.x = 1;
    this.position.z = 0;
    this.position.y = 0;
    this.zoom = CAMERA_ZOOM_MIN;
    this.updateProjectionMatrix();
  }
}

module.exports = { OrbitalCamera, CAMERA_ZOOM_MIN, CAMERA_ZOOM_MAX };
